import React, { useState } from 'react';
import TextWithInputs from 'src/pages/reportUsage/common/textWithInputs/TextWithInputs';
import TextWithClicks from 'src/pages/reportUsage/common/textWithClicks/TextWithClicks';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import edit from 'src/assets/images/Edit.svg';
import ItemPricesRPMobile from './ItemPricesRPMobile';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import LotSerialRPQtyInputMobile from './LotSerialRPQtyInputMobile';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import PoInfoView from '../../PoInfoView';
import { Grid, Divider } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { RemovePoText } from 'src/pages/reportUsage/record/components/priceItems/priceButton.styled';
import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { isIpad, isMobileView } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { StyledDiv } from 'src/pages/consignmentBilling/components/billing/BillingContainer.styled';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const ItemRPTemplateMobile = ({
    classes,
    item,
    index,
    editItem,
    editedItemList,
    addSerialNumber,
    lotSerialValueEntered,
    deleteItem,
    displayPrice,
    showBundlefromTableList,
    isChildItem,
    isFromReportScreen,
    checkboxReportPaymentClickHandler,
    checkNewAddedProduct,
    deletePO,
    isCheckBoxSelected,
    myCaseResourceType,
    collapseChildItem,
    showChildItem,
    vendorCaseErrorRedirection,
    onIsSerialUnknown,
    childRef,
}) => {
    const { t } = useTranslation();
    const mediaSizes = {
        titleArea: 6,
        buttonnsArea: 6,
        xs: 3,
        sm: 12,
        lg: 2,
    };
    const winWidth = window.innerWidth;

    const [disableCheckBox, setDisableCheckBox] = useState(false);
    const [showDeleteIcon, setDeleteIcon] = useState(true);

    useEffectWithErrorLogging(() => {
        const value =
            myCaseResourceType === 'reportPayment' &&
            !item.isDeleteButtonPresent &&
            !checkNewAddedProduct
                ? true
                : item.salesOrg != '' && item.salesOrg
                ? false
                : true;
        const deleteIcon =
            myCaseResourceType === 'reportPayment' &&
            !item.isDeleteButtonPresent &&
            !checkNewAddedProduct
                ? false
                : true;
        setDisableCheckBox(isChildItem ? true : value);
        setDeleteIcon(deleteIcon);
    }, [item]);

    return (
        <>
            <Grid container alignItems={'flex-start'}>
                <Grid
                    item
                    sm={12}
                    md={3}
                    lg={3}
                    xs={12}
                    style={{ display: 'flex' }}
                >
                    <Grid item xs={1} sm={1}>
                        <Checkbox
                         id={`checkbox-report-payment-${item.productCFN}-${index}`}
                            checked={isCheckBoxSelected}
                            onCheckboxSelectionChange={(e) =>
                                checkboxReportPaymentClickHandler(
                                    e,
                                    item,
                                    index
                                )
                            }
                            checkboxBorder={'1px solid #555555 !important'}
                            disabled={disableCheckBox}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={11}
                        sm={11}
                        style={{
                            display: 'flex',
                            flexDirection: isMobileView() ? 'column' : 'row',
                            flexWrap: isMobileView() ? 'nowrap' : 'wrap',
                            marginLeft: !isMobileView() && '-3.5%',
                        }}
                    >
                        <Grid item xs={12} sm={6}>
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <DescriptionContainer>
                                    {item.isEditable ||
                                    (item.isInvalidItemMsg ===
                                        t(
                                            'reportUsage.procedure.unidSurgery.SurgeryOrReport.ProductNotfound'
                                        ) &&
                                        !item.isBundleItem) ? (
                                        <TextWithInputs
                                            type="text"
                                            name="productCFN"
                                            defaultValue={
                                                item.productCFN
                                                    ? item.productCFN
                                                    : ''
                                            }
                                            autoFocus={true}
                                            onkeyUp={(e) =>
                                                editedItemList(e, item, index)
                                            }
                                            inputHeight={'40px'}
                                            inputBorder={
                                                item.isInvalidItemMsg
                                                    ? '2px solid #FACFD9'
                                                    : '2px solid #EBEDED'
                                            }
                                        />
                                    ) : (
                                        <TextWithClicks
                                            classes={classes}
                                            media={mediaSizes}
                                            leftTitle={item.productCFN}
                                            typeNonTissue={
                                                !item.bundleItem &&
                                                (item.salesOrg === 'S002'
                                                    ? 'NT'
                                                    : item.salesOrg === 'S030'
                                                    ? 'T'
                                                    : undefined)
                                            }
                                            typeEA={
                                                !item.bundleItem && item.uom
                                            }
                                            buttonImg={edit}
                                            editAction={() =>
                                                editItem(item, index)
                                            }
                                            alignItemsVal={'flex-start'}
                                            justifyContentVal={'flex-end'}
                                            typeBundle={
                                                item.bundleItem &&
                                                t(
                                                    'templates.common.addItemBundlePop.bundleItems.bundle'
                                                )
                                            }
                                            isChildItem={isChildItem}
                                            fromReportPayment={true}
                                            item={item}
                                            collapseChildItem={
                                                collapseChildItem
                                            }
                                            showChildItem={showChildItem}
                                            isNewProduct={checkNewAddedProduct}
                                        />
                                    )}
                                </DescriptionContainer>
                                {!item.isEditable && item.description && (
                                    <CustomLabel
                                        fSize={
                                            isIpad()
                                                ? '12px !important'
                                                : '13px !important'
                                        }
                                        label={item.description}
                                        letterSpacing={'-0.1px'}
                                        color={isIpad() ? '#140F4B' : '#000000'}
                                        fontFamily={'AvenirNextWorld Regular'}
                                    />
                                )}
                                {item.isInvalidItemMsg && (
                                    <AlertMessageBox
                                        width={isChildItem ? '100%' : '90%'}
                                    >
                                        <AlertMsg
                                            message={item.isInvalidItemMsg}
                                        />
                                    </AlertMessageBox>
                                )}
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={2}
                                lg={2}
                                style={{
                                    marginTop: '5px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <LotContainer
                                    checkNewAddedProduct={checkNewAddedProduct}
                                    mbAlignItems={
                                        !checkNewAddedProduct && 'flex-end'
                                    }
                                >
                                    {!checkNewAddedProduct &&
                                    isChildItem &&
                                    !item.lotSerialNumber ? null : (
                                        <>
                                            {!checkNewAddedProduct &&
                                                isFromReportScreen && (
                                                    <Box
                                                        style={{
                                                            fontFamily:
                                                                'AvenirNextWorld Demi',
                                                            fontSize: '13px',
                                                        }}
                                                    >
                                                        {t(
                                                            'reportUsage.itemList.lotSerialInputPlaceHolder.lotOrSerial'
                                                        )}
                                                    </Box>
                                                )}
                                        </>
                                    )}
                                    <LotSerialRPQtyInputMobile
                                        item={item}
                                        index={index}
                                        addSerialNumber={addSerialNumber}
                                        lotSerialValueEntered={
                                            lotSerialValueEntered
                                        }
                                        deleteItem={deleteItem}
                                        showBundlefromTableList={
                                            showBundlefromTableList
                                        }
                                        isChildItem={isChildItem}
                                        isFromReportScreen={isFromReportScreen}
                                        checkNewAddedProduct={
                                            checkNewAddedProduct
                                        }
                                        winWidth={winWidth}
                                        vendorCaseErrorRedirection={
                                            vendorCaseErrorRedirection
                                        }
                                        onIsSerialUnknown={onIsSerialUnknown}
                                        ref={childRef}
                                    />
                                </LotContainer>
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                xl={12}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    paddingTop: '5px',
                                }}
                            >
                                {(item?.isInvalidLotSerialMsg ||
                                    item?.isInvalidQtyMsg) && (
                                    <>
                                        {item?.isInvalidQtyMsg && (
                                            <div style={{ display: 'flex' }}>
                                                <AlertMsg
                                                    message={
                                                        item.isInvalidQtyMsg
                                                    }
                                                />
                                            </div>
                                        )}
                                        {item?.isInvalidLotSerialMsg && (
                                            <div style={{ display: 'flex' }}>
                                                <AlertMsg
                                                    message={
                                                        item.isInvalidLotSerialMsg
                                                        // ? item.isInvalidLotSerialMsg
                                                        // : item?.isInvalidQtyMsg &&
                                                        //   item?.isInvalidQtyMsg
                                                    }
                                                    linkedSstref={
                                                        item?.isInvalidLotSerialMsg
                                                            ? item?.isInvalidLotSerialMsg?.includes(
                                                                  'discard'
                                                              ) &&
                                                              item?.cfn?.startsWith(
                                                                  'S33'
                                                              )
                                                                ? item?.linkedSstref
                                                                : ''
                                                            : ''
                                                    }
                                                    vendorCaseErrorRedirection={
                                                        vendorCaseErrorRedirection
                                                    }
                                                />
                                            </div>
                                        )}
                                    </>
                                )}
                            </Grid>
                            {item?.lotSerialUnknownApplicable &&
                                (item?.isSerialRequired ||item?.isBatchRequired) && (
                                    <StyledDiv margin={'10px 0 0 0'}>
                                        <Checkbox
                                            id={`reportUsage-reportPayment-mobile-item-lotSerialUnknown-checkbox-${item.productCFN}-${index}`}
                                            label={t(
                                                'reportUsage.lotSerialUnknown'
                                            )}
                                            checked={
                                                item?.lotSerialUnknown
                                                    ? item?.lotSerialUnknown
                                                    : !item?.lotSerialUnknownApplicable
                                            }
                                            onCheckboxSelectionChange={() =>
                                                onIsSerialUnknown(
                                                    item,
                                                    index,
                                                    item?.lotSerialUnknown ===
                                                        true ||
                                                        item?.lotSerialUnknown ===
                                                            false
                                                        ? !item?.lotSerialUnknown
                                                        : item?.lotSerialUnknownApplicable,
                                                    0
                                                )
                                            }
                                            fontSize={'12px'}
                                            color={'#373737'}
                                            margin={'2px 8px 0px 0px'}
                                        />
                                    </StyledDiv>
                                )}
                        </Grid>

                        {isMobileView() && !isChildItem && (
                            <DividerContainer>
                                <Divider orientation="horizontal" />
                            </DividerContainer>
                        )}
                        <Grid item xs={12} sm={6}>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <ItemPricesRPMobile
                                    classes={classes}
                                    displayPrice={displayPrice}
                                    isBundleItem={item.isBundleItem}
                                    checkNewAddedProduct={checkNewAddedProduct}
                                    item={item}
                                    index={index}
                                    addSerialNumber={addSerialNumber}
                                    lotSerialValueEntered={lotSerialValueEntered}
                                    isChildItem={isChildItem}
                                    isFromReportScreen={isFromReportScreen}
                                    deleteItem={deleteItem}
                                    winWidth={winWidth}
                                    showDeleteIcon={showDeleteIcon}
                                />
                            </Grid>
                        </Grid>

                        <Grid item xs={12} sm={6} style={{ marginTop: '15px' }}>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <Grid item xs={8} md={2} lg={2}>
                                    {item?.payment?.poAttachment ? (
                                        item.payment.poAttachment
                                            ?.split(',')
                                            .map((ele) => (
                                                <PoInfoView
                                                    key={ele}
                                                    fileName={ele}
                                                    item={item}
                                                />
                                            ))
                                    ) : (
                                        <PoInfoView item={item} />
                                    )}
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    md={1}
                                    lg={1}
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    {showDeleteIcon &&
                                    item.poImageErrorMsg !==
                                        t(
                                            'productValidationMessages.poInfoRequired'
                                        ) ? (
                                        <>
                                            {item?.payment &&
                                                item.payment !== '' &&
                                                item.payment?.poNumber && (
                                                    <RemovePoText
                                                        id={`reportUsage-reportPayment-mobile-item-removePo-text-${item.productCFN}-${index}`}
                                                        onClick={() =>
                                                            item?.payment &&
                                                            item.payment !==
                                                                '' &&
                                                            deletePO(
                                                                item,
                                                                index
                                                            )
                                                        }
                                                    >
                                                        {t(
                                                            'reportUsage.record.reportPayment.ItemList.ReportPaymentItemListMobile.removePo'
                                                        )}
                                                    </RemovePoText>
                                                )}
                                        </>
                                    ) : null}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

export default ItemRPTemplateMobile;

export const LotContainer = styled.div`
    ${media.mobileDevice`
    display: flex;
    justify-content : ${({ checkNewAddedProduct }) =>
        checkNewAddedProduct ? 'space-between' : 'unset'};
    width: ${({ checkNewAddedProduct }) =>
        checkNewAddedProduct ? '100%' : 'unset'};
    `}
    ${media.smalDevice`
    display: flex;
    justify-content : ${({ checkNewAddedProduct }) =>
        checkNewAddedProduct ? 'space-between' : 'unset'};
    width: ${({ checkNewAddedProduct }) =>
        checkNewAddedProduct ? '100%' : 'unset'};
    `};
    ${media.mobileDevice`    
        align-items: ${({ mbAlignItems }) => mbAlignItems};
     `}
`;

export const DividerContainer = styled.div`
    margin: 8px 0px 8px -25px;
`;
export const DescriptionContainer = styled.div`
    display: flex;
`;
export const AlertMessageBox = styled.div`
    display: flex;
    width: ${({ width }) => width};
`;
